'use es6';

import { parse } from 'hub-http/helpers/params';
import { useLocation } from 'react-router-dom';
import { FILTER_TYPES, FILTER_TYPES_OTHER } from '../constants/TopFilterConstants';
const useFilterParams = () => {
  const location = useLocation();
  const params = parse(location.search.slice(1));
  const paramsSanitized = {};
  Object.keys(params).forEach(param => {
    const allFilterTypes = [...Object.values(FILTER_TYPES), ...Object.values(FILTER_TYPES_OTHER)];
    if (allFilterTypes.includes(param)) {
      paramsSanitized[param] = params[param];
    }
  });
  return paramsSanitized;
};
export default useFilterParams;